import type { ChainConfig } from "@/domains/core/types"

const branch = import.meta.env.VITE_DO_GIT_BRANCH || "main"
/**
 * Static application configuration for Base production
 * This replaces the dynamic XCHAIN config system
 */
export const appConfig: ChainConfig = {
  name: "Base",
  description: "Prod site on Base",
  chainId: 8453,
  slug: "base",
  branch,
  scanner: {
    name: "Base scan",
    url: "https://basescan.org/",
    tokenUrl: "https://basescan.org/token/{tokenAddress}",
    addressUrl: "https://basescan.org/address/{address}",
  },
  env: {
    RPC_PROVIDER_URL: "BASE_RPC_PROVIDER_URL",
  },
  bannedPairs: [
    { address: "0x901d03b042170394828c0781d6a055264219ee74", reason: "JANITOR" },
    { address: "0x03dcfe145caa59eb5d9b98b3b5b86c9a83f667aa", reason: "KEVIN" },
    { address: "0xf05d798be37b7b0f2e36941ab84484d7e140f3a6", reason: "NULL" },
    { address: "0x2e1a6f81895b5dd22cb65d80e265c80688afd144", reason: "WOLF" },
  ],
  tokens: {
    governance: {
      name: "SCALE",
      symbol: "SCALE",
      decimals: 18,
      address: "0x54016a4848a38f257b6e96331f7404073fd9c32c",
    },
    vested: {
      name: "veSCALE",
      symbol: "veSCALE",
      decimals: 18,
      address: "0x28c9c71c776a1203000b56c0cca48bef1cd51c53",
    },
    usdc: {
      name: "USDC",
      symbol: "USDC",
      decimals: 6,
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
    },
    native: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
      address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
    },
    wrappedNative: {
      name: "Wrapped ETH",
      symbol: "WETH",
      decimals: 18,
      address: "0x4200000000000000000000000000000000000006",
    },
    wrappedNativePricePair: {
      name: "WETH/SCALE",
      symbol: "VolatileV1 AMM - WETH/SCALE",
      decimals: 18,
      address: "0xc825c67ca3a80d487c339a6c16bb84f7dca16012",
    },
  },
  equalizer: {
    contracts: {
      library: "0x3ba64e3d39aaaf65e1c8bafc37ec91d40256a481",
      router: "0x2F87Bf58D5A9b2eFadE55Cdbd46153a0902be6FA",
      voter: "0x46abb88ae1f2a35ea559925d99fdc5441b592687",
      factory: "0xb136b45e3e241bb0d0c037395446cf42e4db13d6",
      superVoter: "0x0225664E04b25a1eB71A7aD0b93C9Aa6Ec3C74a0",
      veInfo2: "0x68a5d249d9ac9a6404eb816285e61d980df1299f",
      venAmm: "0x39cc1c9691a2d6bef97db057bc09039869f17536",
    },
    lenses: {
      clFarmLens: "0xce6284F7398d77bFc61f66069C9857cA1c86e541",
      equalens25: "0x931389186c11eb3e9dc3fe388b2291ea80327bb7",
      equalens26: "0xcd4f9a345aa5ad9d34e92635d7c1d9b609ae0304",
      infoBribeByNft: "0x5023217a94416ddb2aa4fbf00b4fd24cbf56f04c",
      multiBalance: "0x3979d8149099b98cde35e08722f05dc477f55b97",
      multiBalanceAllowance: "0xfa6d96d605035e23e7f4b14b745da3e133dbe89b",
      Frontend_DefaultPairInfo: "0x291CD03864226A7Bb0fe99eE6DD195B8b09412a7",
      Frontend_UserPairInfo: "0x8C20b5171fA8Fcc62B28a65c3d90B40381c1c584",
      Frontend_UserManageMinimalPoolInfo: "0x09A40ac395a4759a6e1Fa8D26d02C69Acb0d7381",
    },
    emissions: {
      epochZero: 1668038400,
      lastSync: {
        universalEpoch: 2828,
        localEpoch: 25,
        localEpochsElapsed: 24,
        emitted: 169801.6,
        decayFactor: 0.98,
      },
    },
  },
  swap: {
    sources: {
      kyber: true,
      openocean: true,
      fly: true,
    },
  },
  web3: {
    zeroAddress: "0x0000000000000000000000000000000000000000",
    safeAddress: "0x0000000000000000000000000000000000001234",
    multicall: "0xf4f5af3502916314ec17ebc813fd33f5bd29c986",
  },
  links: {
    footer: {
      contracts: "https://docs.equalizer.exchange/scale-base/contracts/",
      tokenomics: "https://docs.equalizer.exchange/scale-base/tokenomics/",
    },
  },
  tax_tokens: [],
  bribeIgnoreTokens: [],
}
